/*
 * バリデーション（ログイン）
 */
import { composeValidators } from '@/utils/libs/react-final-form/validate';
import { isRequiredText, strMax } from '@/utils/validate/conditions';
/**
 * ログイン時のパスワード入力
 */
export const validatePasswordLogin = composeValidators(isRequiredText('パスワードを入力してください'), strMax(50, 'パスワードは50文字以内で入力してください'));
